import React from 'react';
import { withIcon, SvgIconProps } from '../../../../components/withIcon';
const SvgCheckOutlined = ({ size, title = 'CheckOutlined', ...props }: SvgIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        data-icon-name={title}
        aria-label={title}
        role="presentation"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M18 6l-7.496 12L6 13.5"
            />
        </g>
    </svg>
);
export default withIcon(SvgCheckOutlined);
